import Api from '@/axios'

export default {
    addManagement(payload) {
        return Api().post('customers', payload)
    },
    searchCustomer(phone) {
        return Api().get(`customer-search?phone=${phone}`)
    },
    getCustomerDetails(customerId) {
        return Api().get(`customers/${customerId}`)
    },
    getAllPurchases(id) {
        return Api().get(`purchases?user_id=${id}&limit=10000000`)
    },
    addNewPurchase(payload) {
        return Api().post('newPurchase', payload)
    },
    addNewGift(payload) {
        return Api().post('newGift', payload)
    },
    getMyGifts(userId) {
        return Api().get(`gifts?user_id=${userId}`)
    },
    getCopounGift(userId, payload) {
        return Api().get(`gifts?type=coupon&user_id=${userId}&limit=1000&${payload.type == 'ticket' ? `ticket_id=${payload.ticket_id}` : `promotion_id=${payload.promotion_id}`}`)
  },
  collectPurchase (id, serviceId) {
    return Api().post(`collect/${id}`, {
        service_id : serviceId
    })
  },
  refundPurchase (id, amount) {
    return Api().post(`refund/${id}`, {
        amount: amount
    })
  },
  cancelPurchase (id) {
    return Api().get(`cancel/${id}`)
  },
  editPurchase (id, payload) {
    return Api().post(`payment/${id}`, payload)
  }
}